// Environment resolution for the web app. Mirrors the structure of
// apps/mobile/src/config/env.ts so URLs match across platforms.
//
// #env-ts-prod-tree-shake: use a ternary chain (NOT an object literal
// map) so Vite can statically replace `import.meta.env.VITE_APP_ENV`
// at build time and eliminate dead branches. The prior object-literal
// approach kept ALL three URL sets in the bundle regardless of mode —
// caught by build-web-prod.sh's post-build assertion (df174ee) when
// `test.jnati.com` was still findable in a prod build's dist.
//
// With this shape and `VITE_APP_ENV=production` at build time, Vite
// resolves `appEnv === 'staging'` and `appEnv === 'development'` to
// literal `false` and drops those branches entirely, so the only URL
// string in the compiled bundle is `https://jnati.com`.

// Default to production so a build with no VITE_APP_ENV set (e.g. GCP
// build machine with no .env.production shipped) bakes the safe prod
// URLs into the bundle. Local dev overrides via .env.local
// (VITE_APP_ENV=staging) or via .env.example workflow.
const appEnv = import.meta.env.VITE_APP_ENV ?? 'production'

const _resolved = appEnv === 'staging'
  ? {
      API_URL: 'https://test.jnati.com',
      SOCKET_URL: 'https://test.jnati.com',
    }
  : appEnv === 'development'
  ? {
      API_URL: import.meta.env.VITE_DEV_API_URL ?? 'http://localhost:3000',
      SOCKET_URL: import.meta.env.VITE_DEV_SOCKET_URL ?? 'http://localhost:3000',
    }
  : {
      API_URL: 'https://jnati.com',
      SOCKET_URL: 'https://jnati.com',
    }

// One-line console line so the dev console shows which backend is in play.
console.log(
  '[Jnati ENV]',
  'APP_ENV=', appEnv,
  'DEV=', import.meta.env.DEV,
  'API_URL=', _resolved.API_URL,
  'SOCKET_URL=', _resolved.SOCKET_URL,
)

export default _resolved
